import { Header, Breadcrumb, Message, Table, Tab,  Icon, Loader, Dropdown, Transition, Label, Divider, Form,  Checkbox, Dimmer,  TextArea, Button, Step, Grid,Input, Radio, List, Segment, Popup , Menu} from 'semantic-ui-react';
import {Auth} from 'aws-amplify';
import toastr from 'toastr';
///AGREGO GUSTAVO 
import {store} from '../index';

export function setUsuarioMiEspacio( componente, pageOrigen, session){
    
    
    
    let user={
                "idToken":session.getIdToken().getJwtToken()
            }
            componente.props.userActions.addUser(user);
         
            const userInfo={username:session.getIdToken().decodePayload()["cognito:username"], ...session.attributes};
            componente.setState({"userInfo": userInfo});
            
             let pageInfo={
                page:pageOrigen,
                idioma:componente.props.idioma    
            };
            
            
            if(componente.props.menuActions!=null){
                
                componente.props.menuActions.getMenu(user).then( ()=>{
                   
                    componente.props.paginaActions.getInfo(pageInfo, user).then( pageInfoResponse=>{
             
                            if(pageInfoResponse.completarRegistro==1){
                                    //this.props.navigate(-1);
                                   //componente.props.history.push('/completar');
                                    componente.props.navigate('/completar');
                               }
                               componente.setState({"permisos":pageInfoResponse.permisos,
                                             "strings":Object.assign({}, pageInfoResponse.strings)});
                        })
                        .catch(error=>{
                          toastr.error(error);
                        }); 
                    
                    
                         componente.props.inscripcionActions.constancias(user).then( constancias=>{
                               componente.setState({"constancias":constancias});
                                //console.log("get constancias de mi espacio");
                        })
                        .catch(error=>{
                            toastr.error(error);
                        }); 

                        componente.props.usuarioActions.getFotoPerfil(user).then( ()=>{
                                //console.log("getFotoPerfil de mi espacio");
                        })
                        .catch(error=>{
                            toastr.error(error);
                        }); 
               
                    
                    if(componente.props.pagosActions!=null){
                    
                        componente.props.pagosActions.getPagosUsuario(user).then((pagos)=>{
                            componente.setState({pagosLista:pagos});
                        }) 
                        .catch(error=>{ 
                            toastr.error(error); 
                        });

                        componente.props.pagosActions.getPagosPendientes(user).then( pagos=>{
                           componente.setState({"pagos":pagos});
                        })
                        .catch(error=>{
                            toastr.error(error);
                        });

                        //console.log(usuario);
                        componente.props.usuariocursoActions.getUsuarioCursoPrevio(user).then( cursosPrevios=>{
                            componente.setState({"cursosPrevios":cursosPrevios});
                        })
                        .catch(error=>{
                            toastr.error(error);
                        });

                    
                    }
                    
                    
                     componente.props.cursoActions.getCursosActuales(user).then( cursosActuales=>{
                       componente.setState({"cursosActuales":cursosActuales});
                   //console.log("getCursosActuales de mi espacio");
                })
                .catch(error=>{
                    toastr.error(error);
                }); 
                    
                    
                    
                    
                    
                    })
                    .catch(error=>{
                        toastr.error(error);
                    }); 
            }
            
    
            return user;
             
}

export async function validaApiToken(componente){
const session = await Auth.currentSession();
    
    //console.log("Entro a validaApiToken");
    
    if(session!=null){
        var idTokenExpire = session.getIdToken().getExpiration();
        var currentTimeSeconds = Math.round(+new Date() / 1000);
        
        //console.log(idTokenExpire);
        //console.log(currentTimeSeconds);
        
        if (idTokenExpire < currentTimeSeconds) {
            componente.props.userActions.addUser(null);
            //componente.props.history.push('/');
            componente.props.navigate('/');
            Auth.signOut();
            return null;
        }
        let user={
                "idToken":session.getIdToken().getJwtToken()
            };
        
        //console.log(user);
        
        return user;
        
    }else{
        componente.props.userActions.addUser(null);
        //componente.props.history.push('/');
        componente.props.navigate('/');
        Auth.signOut();
        return null;
    } 
    
    
}

export async function renuevaTokenAccion(){
  
const session = await Auth.currentSession();
    if(session!=null){
        //debugger;
            var idTokenExpire = session.getIdToken().getExpiration();
            var refreshToken = session.getRefreshToken();
            var currentTimeSeconds = Math.round(+new Date() / 1000);
            if (idTokenExpire < currentTimeSeconds) {
                const res  = await Auth.currentAuthenticatedUser();
                
                  res.refreshSession(refreshToken, (err, data) => {
                    if (err) {
                       
                        Auth.signOut();
                        return null;
                    } else {
                        
                        let user={
                            "idToken":session.getIdToken().getJwtToken()
                        }
                       return user;
                    }
                  });
            }else{
                let user={
                    "idToken":session.getIdToken().getJwtToken()
                }
                return user;
            }
    }else{
         
            
            Auth.signOut();
        return null;
    }
    
    
    
}




export async function renuevaToken(componente, contenidoVisto ){
const session = await Auth.currentSession();
    if(session!=null){
            var idTokenExpire = session.getIdToken().getExpiration();
            var refreshToken = session.getRefreshToken();
            var currentTimeSeconds = Math.round(+new Date() / 1000);
            if (idTokenExpire < currentTimeSeconds) {
                const res  = await Auth.currentAuthenticatedUser();
                
                  res.refreshSession(refreshToken, (err, data) => {
                    if (err) {
                        componente.props.userActions.addUser(null);
                        //componente.props.history.push('/');
                        componente.props.navigate('/');
                        Auth.signOut();
                    } else {
                        
                        let user={
                            "idToken":session.getIdToken().getJwtToken()
                        }
                       componente.props.cursoActions.setVisto(contenidoVisto, user).then( ()=>{

                        }).catch(error=>{
                              toastr.error(error);
                        });
                    }
                  });
            }else{
                let user={
                    "idToken":session.getIdToken().getJwtToken()
                }
                componente.props.cursoActions.setVisto(contenidoVisto, user).then( ()=>{

                }).catch(error=>{
                      toastr.error(error);
                });
            }
    }else{
        //componente.props.history.push('/');
        componente.props.navigate('/');
            
            Auth.signOut();
    }
    
    
    
}

export async function usuarioActualMiEspacio( componente, pageOrigen, requerido){
    
    componente.props.userActions.setPaginaActual(pageOrigen);
    const session = await Auth.currentSession();
    if(session!=null)
	   {
               
            var idTokenExpire = session.getIdToken().getExpiration();
            var refreshToken = session.getRefreshToken();
            var currentTimeSeconds = Math.round(+new Date() / 1000);
            if (idTokenExpire < currentTimeSeconds) {
              const res  = await Auth.currentAuthenticatedUser();
                
                  res.refreshSession(refreshToken, (err, data) => {
                    if (err) {
                        componente.props.userActions.addUser(null);
                        if(requerido==true){
                                //componente.props.history.push('/');
                                componente.props.navigate('/');
                         }
                      Auth.signOut();
                    } else {
                       return  setUsuarioMiEspacio(componente, pageOrigen, session);
                      
                    }
                  });
                
            } else {
                 
                 return setUsuarioMiEspacio(componente, pageOrigen, session);
             
            }
           
          }
           
            componente.props.userActions.addUser(null);
             if(requerido==true){
                    componente.props.navigate('/');
                    //componente.props.history.push('/');
             }
            Auth.signOut();
         
}




export function setUsuario( componente, pageOrigen, session){
   
    componente.props.userActions.setPaginaActual(pageOrigen);
    
    let user={
                "idToken":session.getIdToken().getJwtToken()
            }
            componente.props.userActions.addUser(user);
         
            const userInfo={username:session.getIdToken().decodePayload()["cognito:username"], ...session.attributes};
            componente.setState({"userInfo": userInfo});
            
             let pageInfo={
                page:pageOrigen,
                idioma:componente.props.idioma    
            };
            
            //console.log(componente.props.menuActions);
            if(componente.props.menuActions!=null){
                //console.log("componente.props.menuActions!=null");
                componente.props.menuActions.getMenu(user).then( ()=>{
                   
                    componente.props.paginaActions.getInfo(pageInfo, user).then( pageInfoResponse=>{
             
                            if(pageInfoResponse.completarRegistro==1){
                                   //componente.props.history.push('/completar');
                                    componente.props.navigate('/');
                               }
                        
                                //console.log("pageInfoResponse.strings");
                                //console.log(pageInfoResponse.strings);
                        
                               componente.setState({"permisos":pageInfoResponse.permisos,
                                             "strings":Object.assign({}, pageInfoResponse.strings)});
                        })
                        .catch(error=>{
                          toastr.error(error);
                        }); 
                    
                    
                    })
                    .catch(error=>{
                        toastr.error(error);
                    }); 
            }
            
    
            return user;
             
}

export async function usuarioActual( componente, pageOrigen, requerido){
    try {
        const session = await Auth.currentSession();
    
        if(session!=null)
        {
            var idTokenExpire = session.getIdToken().getExpiration();
            var refreshToken = session.getRefreshToken();
            var currentTimeSeconds = Math.round(+new Date() / 1000);
            if (idTokenExpire < currentTimeSeconds) {

              const res  = await Auth.currentAuthenticatedUser();

                  res.refreshSession(refreshToken, (err, data) => {
                    if (err) {
                        componente.props.userActions.addUser(null);
                        if(requerido==true){
                                //console.log("requerido==true if");
                                //componente.props.history.push('/');
                            componente.props.navigate('/');
                         }
                      Auth.signOut();
                    } else {
                       return  setUsuario(componente, pageOrigen, session);

                    }
                  });

            } else {
                 return setUsuario(componente, pageOrigen, session);

            }

          }
        
        

    } catch (error) {
        

        if(requerido==true){
            //componente.props.history.push('/');
            componente.props.navigate('/');
        }
        Auth.signOut();
    }
 
    //const session = await Auth.currentSession();
    /*
    if(session!=null)
	   {
            var idTokenExpire = session.getIdToken().getExpiration();
            var refreshToken = session.getRefreshToken();
            var currentTimeSeconds = Math.round(+new Date() / 1000);
            if (idTokenExpire < currentTimeSeconds) {
                
              const res  = await Auth.currentAuthenticatedUser();
                
                  res.refreshSession(refreshToken, (err, data) => {
                    if (err) {
                        componente.props.userActions.addUser(null);
                        if(requerido==true){
                                //console.log("requerido==true if");
                                componente.props.history.push('/');
                         }
                      Auth.signOut();
                    } else {
                       return  setUsuario(componente, pageOrigen, session);
                      
                    }
                  });
                
            } else {
                 return setUsuario(componente, pageOrigen, session);
             
            }
           
          }
     
        componente.props.userActions.addUser(null);
        if(requerido==true){
            componente.props.history.push('/');
        }
        Auth.signOut();
*/
}


export function findObjectById(arreglo, id){
	const objeto=arreglo.filter(objeto=> Number(objeto.id)===Number(id));
	if(objeto) return objeto[0];
	return null;
}

export function findObjectByKey(arreglo, key){
    
	const objeto=arreglo.filter(objeto=> Number(objeto.key)===Number(key));
	if(objeto) return objeto[0];
	return null;
}


export function getMargenes(sidebarActiva, sidebarEnable){
      let margenes={ };
         if(sidebarActiva && sidebarEnable){
            margenes={marginTop: '2.5em', marginLeft: '1%',  minHeight:'88vh', marginRight: '25.3%', marginBottom:'2em'};   
        }else{
            margenes={marginTop: '2.5em', marginLeft: '3%', minHeight:'88vh', marginRight: '3%',   marginBottom:'2em'};
        }
    return margenes;
}


export function getMargenesBlack(sidebarActiva, sidebarEnable){
      let margenes={ };
         if(sidebarActiva && sidebarEnable){
            margenes={backgroundColor: "black", marginTop: '1em', marginLeft: '1%',  minHeight:'88vh', marginRight: '25.3%', marginBottom:'2em'};   
        }else{
            margenes={backgroundColor: "black", marginTop: '1em', marginLeft: '3%', minHeight:'88vh', marginRight: '3%',   marginBottom:'2em'};
        }
    return margenes;
}

export function getLocacion(){
		 
     let ruta=window.location.pathname;
    ruta=ruta.split("/");
    if(ruta.length>2){
        ruta="/"+ruta[1];
    }else{
        ruta="";
    }
    ruta="";
    return ruta;
           
}




export function getSegmentoFormulario(componente, onChange){
    
	
    if(componente.type=="Input"){
       
       return <Form.Field  required={componente.required}  error={componente.error} >            
        <label  >{componente.label}</label>
         <Input 
            posicion={componente.posicion} 
            placeholder={componente.placeholder} 
            name={componente.name} 
            onChange={onChange}
            value={componente.value} 
            icon={componente.icon} />
        </Form.Field>
    }
	return "sin campo";
}

export function moneda(numero) {
	if(!isNaN(numero)){
		return "$"+Number(numero).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");	
	}
	return 0;
}

export function stringToDate(dateString){

    var dateObj = new Date(dateString);

    var monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
					  "Julio", "Agosto", "Septiembre", "Octubre",
					  "Noviembre", "Diciembre"];
		var curr_date = dateObj.getDate();
		var curr_month = dateObj.getMonth();
		var curr_year = dateObj.getFullYear();
		var curr_min = dateObj.getMinutes();
		var curr_hr = dateObj.getHours();
		//var curr_sc = dateObj.getSeconds();
		if (curr_month.toString().length === 1)
		//curr_month = '0' + curr_month;      
			if (curr_date.toString().length === 1)
				curr_date = '0' + curr_date;
		if (curr_hr.toString().length === 1)
			curr_hr = '0' + curr_hr;
		if (curr_min.toString().length === 1)
			curr_min = '0' + curr_min;

    //console.log(curr_hr);
    if(curr_hr!="00"){		
        return curr_date + " de " + monthNames[curr_month] + " de " + curr_year + " / " +curr_hr + ":" + curr_min + "  " ;
    }else{
        return curr_date + " de " + monthNames[curr_month] + " de " + curr_year ;
    }  
}

export function cargarPagina(component, idioma){
    //console.log(component.props.paginaActual);
    //console.log(idioma);
    component.cambiarIdioma(component.props.paginaActual, idioma);
    
}

